mutation AgentRequestUploadUrl($input: RequestUploadUrlInput!) {
  requestUploadUrl(input: $input) {
    uploadUrl
    key
    bucket
    expiresIn
    expiresAt
  }
}
